import React, { useEffect, useState, useContext } from "react";
import { Grid, Paper, IconButton, Box } from "@mui/material";
import Tabela from "../../../../componentsv2/Tabela";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { Input } from "../../../../componentsv2/Input";
import { ModalForm } from "../../../../componentsv2/ModalForm";
import Opcoes from "./opcoes";
import { Select } from "../../../../componentsv2/Select";
import { useSnackbar } from "notistack";
import { api } from "../../../../services/Api";
import { Context as PermissoesContext } from "../../../../Context/PermissoesContext";

export default function Material() {
  const [materialModal, setMaterialModal] = useState(false);
  const [arrayMateriais, setArrayMateriais] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const [arrayDeTipos, setArrayDeTipos] = useState([]);
  const [marca, setMarca] = useState("");
  const [modelo, setModelo] = useState("");
  const [descricao, setDescricao] = useState("");
  const [tipoMaterial, setTipoMaterial] = useState("");
  const [ativo, setAtivo] = useState(true);
  const [id, setId] = useState("");
  const { checarPermissao, checarPermissaoSemLog } = useContext(PermissoesContext);

  const [update, setUpdate] = useState(false);
  const [errors, setErrors] = useState({});
  const [pesquisa, setPesquisa] = useState("");

  const handleChangeSearch = e => {
    setPesquisa(e.target.value);
  };

  async function getTipoDeMaterialEdit() {
    try {
      const {
        data: { data },
      } = await api.get(`/v2/inventario/material/${id}`);
      setMarca(data.marca);
      setModelo(data.modelo);
      setDescricao(data.descricao);
      setTipoMaterial(data.tipoMaterialId);
      setAtivo(data.ativo);
    } catch (error) {
      enqueueSnackbar("Erro! Não foi possível buscar o material.", {
        variant: "error",
      });
    }
  }

  useEffect(() => {
    if (id) {
      getTipoDeMaterialEdit();
    }
    // eslint-disable-next-line
  }, [id]);

  useEffect(() => {
    async function getMateriais() {
      try {
        const { data } = await api.get(`/v2/inventario/materiais`);

        const materiais = data.data.map(element => ({
          ...element,
          nomeTipoMaterial: element.tipoMaterial.nome,
        }));

        setArrayMateriais(materiais);
      } catch (error) {
        enqueueSnackbar("Erro! Não foi possível buscar os materiais.", {
          variant: "error",
        });
      }
    }
    getMateriais();
  }, [update, checarPermissaoSemLog, enqueueSnackbar]);

  useEffect(() => {
    async function getTiposDeMateriais() {
      try {
        const {
          data: { data },
        } = await api.get(`/v2/inventario/tiposMateriais`);

        function ativos(value) {
          return value.ativo === true;
        }

        const tiposAtivos = data.filter(ativos);

        setArrayDeTipos(tiposAtivos);
      } catch (error) {
        enqueueSnackbar("Erro! Não foi possível buscar os tipos de materiais.", {
          variant: "error",
        });
      }
    }
    getTiposDeMateriais();
  }, [enqueueSnackbar, tipoMaterial, update]);

  const clearFields = () => {
    setMarca("");
    setModelo("");
    setDescricao("");
    setTipoMaterial("");
    setAtivo(true);
    setId("");
    setErrors({});
  };

  const handleFieldChange = (fieldName, value, setter) => {
    setter(value);
    if (errors[fieldName]) {
      setErrors({ ...errors, [fieldName]: "" });
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();
    
    const newErrors = {};
    if (!tipoMaterial) {
      newErrors.tipoMaterial = "Tipo do Material é obrigatório";
    }
    if (!marca || marca.trim() === "") {
      newErrors.marca = "Marca é obrigatória";
    }
    if (!modelo || modelo.trim() === "") {
      newErrors.modelo = "Modelo é obrigatório";
    }
    
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      enqueueSnackbar("Preencha todos os campos obrigatórios corretamente", {
        variant: "error",
        autoHideDuration: 3000,
      });
      return;
    }

    try {
      const data = {
        marca,
        modelo,
        descricao,
        tipoMaterialId: tipoMaterial,
        ativo,
      };

      if (id) {
        await api.put(`/v2/inventario/material/${id}`, data);
        setUpdate(!update);
        enqueueSnackbar("Material editado com sucesso!", {
          variant: "success",
          autoHideDuration: 3000,
        });
      } else {
        await api.post(`/v2/inventario/material`, data);
        setUpdate(!update);
        enqueueSnackbar("Material cadastrado com sucesso!", {
          variant: "success",
          autoHideDuration: 3000,
        });
      }

      clearFields();
      setMaterialModal(false);
    } catch (error) {
      const mensagem = error.response?.data?.messages || 
                       error.response?.data?.message || 
                       error.response?.data?.error || 
                       "Erro ao tentar criar um material.";
      enqueueSnackbar(mensagem, {
        variant: "error",
        autoHideDuration: 3000,
      });
    }
  };

  const columns = [
    { field: "marca", headerName: "Marca", width: 200, type: "text" },
    {
      field: "modelo",
      headerName: "Modelo",
      width: 200,
      editable: true,
      type: "text",
    },
    {
      field: "descricao",
      headerName: "Descricao",
      width: 250,
      editable: true,
      type: "text",
    },
    {
      field: "nomeTipoMaterial",
      headerName: "Tipo do Material",
      width: 180,
      editable: true,
      type: "text",
    },
    {
      field: "ativo",
      headerName: "Situação",
      width: 120,
      type: "text",
      valueGetter: ({ value }) => (value === true ? "Ativo" : "Inativo"),
    },
    {
      field: "opcoes",
      headerName: "Opções",

      width: 150,

      renderCell: params => (
        <div style={{ cursor: "pointer" }}>
          <Opcoes 
            setId={setId} 
            setMaterialModal={setMaterialModal} 
            row={params.row}
            setUpdate={setUpdate}
            update={update}
          />
        </div>
      ),
    },
  ];

  const filtrarMateriais = pesquisa
    ? arrayMateriais.filter(material => {
        const pesquisaLower = pesquisa.toString().toLowerCase();
        const marcaMatch = material.marca
          ? material.marca.toString().toLowerCase().includes(pesquisaLower)
          : false;
        const modeloMatch = material.modelo
          ? material.modelo.toString().toLowerCase().includes(pesquisaLower)
          : false;
        return marcaMatch || modeloMatch;
      })
    : arrayMateriais;

  return (
    <Grid container alignItems="center" spacing={2} direction="column">
      <Grid container xs={12} item>
        <Paper sx={{ width: "100%", marginBottom: "30px", padding: "10px" }}>
          <Grid item container sx={{ marginLeft: "5px" }} justifyContent="space-between">
            <Grid item xs={6}>
              <Input
                onChange={e => handleChangeSearch(e)}
                value={pesquisa}
                label="Pesquise pelo nome"
                variant="standard"
                size="small"
                fullWidth
                type="text"
              />
            </Grid>
            <Grid xs={2} sm={2} md={1} lg={1} item>
              <IconButton
                onClick={() => {
                  if (checarPermissao("INV015")) {
                    setMaterialModal(true);
                  } else {
                    enqueueSnackbar(
                      "Você não possui permissão para cadastrar um material!",
                      {
                        variant: "error",
                        autoHideDuration: 3000,
                      }
                    );
                  }
                }}
                color="success"
                size="large"
              >
                <AddCircleOutlineIcon fontSize="large" />
              </IconButton>
            </Grid>
            <ModalForm
              onSubmit={handleSubmit}
              title={id ? "Editar Material" : "Adicionar Material"}
              onClose={() => {
                setMaterialModal(false);
                clearFields();
              }}
              open={materialModal}
            >
              <Grid item xs={12} sm={12} lg={12}>
                <Select
                  required
                  textAttribute="nome"
                  valueAttribute="id"
                  variant="standard"
                  label="Tipo do Material"
                  value={tipoMaterial}
                  onChange={e => handleFieldChange("tipoMaterial", e.target.value, setTipoMaterial)}
                  arrayOptions={arrayDeTipos}
                  error={!!errors.tipoMaterial}
                  helperText={errors.tipoMaterial}
                />
              </Grid>
              <Grid item xs={12} sm={12} lg={12}>
                <Input
                  value={marca}
                  onChange={e => handleFieldChange("marca", e.target.value, setMarca)}
                  required
                  fullWidth
                  variant="standard"
                  label="Marca"
                  type="text"
                  error={!!errors.marca}
                  helperText={errors.marca}
                />
              </Grid>
              <Grid item xs={12} sm={12} lg={12}>
                <Input
                  value={modelo}
                  onChange={e => handleFieldChange("modelo", e.target.value, setModelo)}
                  required
                  fullWidth
                  variant="standard"
                  label="Modelo"
                  type="text"
                  error={!!errors.modelo}
                  helperText={errors.modelo}
                />
              </Grid>
              <Grid item xs={12} sm={12} lg={12}>
                <Input
                  value={descricao}
                  onChange={e => setDescricao(e.target.value)}
                  multiline
                  maxRows={5}
                  fullWidth
                  variant="standard"
                  label="Descrição"
                  type="text"
                />
              </Grid>
            </ModalForm>
          </Grid>
        </Paper>
      </Grid>
      <Grid item xs={12} container>
        <Grid style={{ paddingTop: "10px" }} xs={12} sm={12} item>
          <Grid spacing={2} container>
            <Grid style={{ paddingTop: "10px" }} item xs={12} sm={12}>
              <Paper elevation={2}>
                <Box
                  sx={{
                    height: 1,
                    width: "100%",
                    marginBottom: "10px",
                  }}
                >
                  <div>
                    <Tabela rows={filtrarMateriais} columns={columns} autoHeight />
                  </div>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
